import WordKnowledgeControls from '@/components/QuizPage/WordKnowledgeControls/WordKnowledgeControls';
import classes from 'classnames';
import classNames from './WordsListItem.module.scss';
import { Question } from '@/types/question';
import SVG from 'react-inlinesvg';
import React from 'react';
import { useAppSelector } from '@/store';
import { authSelector } from '@/store/reducers/auth';
import soundPlay from '@/assets/svg/speaker.svg';
import UseScreenSize from '@/hooks/UseScreenSize';
import { useTranslation } from 'react-i18next';

interface WordsListItemProps {
  question: Question | null;
  emitOnAknowledge?: (id: number, isKnown: boolean) => void;
}

const WordsListItem = ({ question, emitOnAknowledge }: WordsListItemProps) => {
  const { t } = useTranslation();
  const { isMobile, isDesktop } = UseScreenSize();

  const answerText = question?.newData?.data?.questionDataLocal?.answer?.text ?? question?.answer;
  const onPlaySound = () => {
    if (question?.dictionaryDetails?.audio) {
      new Audio(question?.dictionaryDetails?.audio).play();
    }
  };

  const soundBtn = question?.dictionaryDetails?.audio && (
    <button
      className={classNames.soundBtn}
      onClick={onPlaySound}
      aria-label={t('play_sound') || ''}
    >
      <SVG src={soundPlay} />
    </button>
  );

  const partOfSpeach = (
    <span className={classNames.partOfSpeech}>{question?.dictionaryDetails?.partOfSpeech}</span>
  );
  const { nativeLanguage } = useAppSelector(authSelector);
  return (
    <div className={classNames.wordsListItem}>
      <div className='flex items-center justify-between'>
        <div className='flex items-center gap-2'>
          {isMobile && soundBtn}
          <span className={classNames.entry}>{question?.question}</span>
          {isDesktop && partOfSpeach}
        </div>
        <div className='flex items-center gap-2'>
          <WordKnowledgeControls
            className='flex-row-reverse'
            isSmall={true}
            question={question}
            emitOnAknowledge={emitOnAknowledge}
          />
          {isDesktop && soundBtn}
        </div>
      </div>
      {isMobile && partOfSpeach}
      <span
        className={classes(
          classNames.translation,
          ['he', 'ar'].includes(nativeLanguage || '') ? classNames.rtl : ''
        )}
      >
        {answerText}
      </span>
    </div>
  );
};

export default React.memo(WordsListItem);
